import React from "react";
import { Container } from "react-bootstrap";
import { ArticleSection, StyledButton, PageHeaderSection, CardGroupWithSlideshow, DividerSection } from "../components";
import { useScrollToTopAndNavigate, useWindowSize } from "../hooks";
import { useTranslation } from "react-i18next";

import bg_01 from "./../images/Content/Backhaus-Häussler-57.jpg"
import bg_03 from "./../images/Content/Backhaus-Häussler-34.jpg"
import bg_05 from "./../images/Content/haeussler-job-01.webp"

import sliderImg_01 from "./../images/Content/energiesparen.webp"
import sliderImg_02 from "./../images/Content/erneuerbare.webp"
import sliderImg_03 from "./../images/Content/regional.webp"

const Main: React.FunctionComponent = () => {
  const handleNavigation = useScrollToTopAndNavigate();
  const { t } = useTranslation(["main", "common"]);
  const { width } = useWindowSize();

  const cardsData = [
    { title: t("sections.cards.regional.title"), text: t("sections.cards.regional.text"), imageUrl: sliderImg_03 },
    { title: t("sections.cards.renewable.title"), text: t("sections.cards.renewable.text"), imageUrl: sliderImg_02 },
    { title: t("sections.cards.energySaving.title"), text: t("sections.cards.energySaving.text"), imageUrl: sliderImg_01 },
  ];
  
  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    color: "#342714",
    letterSpacing: ".05em"
  };

  return (
    <Container>
      <PageHeaderSection
        id={"section_start"}
        headline={t("page_header.headline")}
        subheadline={t("page_header.subheadline")}
        content={
          <p style={{ ...contentStyle, textAlign: "center" }}>{t("page_header.content")}</p>
        }
      />
      <DividerSection
        imageUrl={bg_01}
        height="55vh"
      />
      <ArticleSection
        layout="article_left_bg"
        title={t("sections.tradition.title")}
        content={
          <div>
            <p style={contentStyle}>{t("sections.tradition.content")}</p>
          </div>
        }
        imageUrl={bg_03}
        backgroundColor="#DDEBEA"
      />
      <PageHeaderSection
        headline={t("sections.sustainability.headline")}
        subheadline={t("sections.sustainability.subheadline")}
        style={{ marginBottom: 100, marginTop: 100 }}
        content={
          <p style={contentStyle}>{t("sections.sustainability.content")}</p>
        }
      />
      <CardGroupWithSlideshow
        cards={cardsData}
        width={width}
      />
      <ArticleSection
        layout="article_right_bg"
        title={t("sections.glutenfree.title")}
        content={
          <div>
            <p style={contentStyle}>{t("sections.glutenfree.content")}</p>
            <StyledButton title={t("sections.glutenfree.button")} onClick={() => { console.log("Button clicked"); }} />
          </div>
        }
        imageUrl={bg_03}
        backgroundColor="#F4EBE5"
      />
      <ArticleSection
        layout="article_left"
        title={t("common:sections.jobs.title")}
        content={
          <div>
            <p style={contentStyle}>{t("common:sections.jobs.content")}</p>
            <StyledButton title={t("common:sections.jobs.button")} onClick={() => {handleNavigation("https://bhmm.de/employees#job-offers", { openInNewTab: true })}} />
          </div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
    </Container>
  );
}

export default Main;
